// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2oYWy","title":"Info_title__14YkT","links":"Info_links__1Ran-","link":"Info_link__jXc0C","logo":"Info_logo__2v3bt"};